export default "__VITE_ASSET__CYKIjfVh__"